import { FC } from 'react';
import type { TreatmentGroup } from '@/model/TreatmentGroup.model';
import { RiSquareFill } from 'react-icons/ri';
import { _isNil } from '@/littledash';
import styles from './GroupCell.module.scss';
import cn from 'classnames';

export type GroupOption = { value: string; label: string; color: TreatmentGroup['color']; no: TreatmentGroup['no'] };
export const GroupCell: FC<{ option?: GroupOption; readOnly?: boolean }> = ({ option, readOnly = false }) => (
  <div
    className="flex flex-row items-center justify-between w-100 h-100"
    data-test-component="GroupCell"
    data-test-element="cell"
    data-test-key={option?.value}
  >
    <div className={cn('flex flex-row items-center gap-h-1', styles.LabelContainer)}>
      {_isNil(option) ? (
        <span>-</span>
      ) : (
        <>
          <RiSquareFill className={styles.Icon} color={option.color} />
          <span className={styles.Label}>{option.label}</span>
        </>
      )}
    </div>
    {readOnly ? null : <span className="htAutocompleteArrow">▼</span>}
  </div>
);
